import { observer } from "mobx-react-lite";
import { cn } from "ui";

import { LogoutMenu } from "./LogoutMenu";

interface Props {
  className?: string;
}

export const NavbarUpgradePaywall = observer(function NavbarUpgradePaywall(
  props: Props,
) {
  return (
    <nav
      className={cn(
        "fixed top-0 z-50 left-0 right-0 h-sztama-auth-toolbar-height flex justify-end items-center border-b bg-white px-2",
        props.className,
      )}
    >
      <LogoutMenu />
    </nav>
  );
});
